import { LoggedUser } from 'modules/users/models/LoggedUser'
import { UserDTO } from 'modules/users/models/User'

export enum SystemRoles {
  PATIENT = 'patient',
  FAMILIAR = 'familiar',
  MED = 'med',
  ADMIN = 'admin',
}

export type UserType = SystemRoles

/**
 * Verifica si el usuario tiene un rol específico
 */
export const hasRole = (user: UserDTO | LoggedUser | undefined | null, role: string): boolean => {
  return user?.roles?.includes(role) || false
}

/**
 * Verifica si el usuario tiene al menos uno de los roles especificados
 */
export const hasAnyRole = (
  user: UserDTO | LoggedUser | undefined | null,
  roles: string[]
): boolean => {
  return user?.roles?.some((role) => roles.includes(role)) || false
}

/**
 * Verifica si el usuario tiene todos los roles especificados
 */
export const hasAllRoles = (
  user: UserDTO | LoggedUser | undefined | null,
  roles: string[]
): boolean => {
  if (!user) return false
  return roles.every((role) => hasRole(user, role))
}

// ============================================
// Verificaciones de roles específicos
// ============================================

export const isPatient = (user: UserDTO | LoggedUser | undefined | null): boolean => {
  return hasRole(user, SystemRoles.PATIENT)
}

export const isFamiliar = (user: UserDTO | LoggedUser | undefined | null): boolean => {
  return hasRole(user, SystemRoles.FAMILIAR)
}

export const isMed = (user: UserDTO | LoggedUser | undefined | null): boolean => {
  return hasRole(user, SystemRoles.MED)
}

export const isAdmin = (user: UserDTO | LoggedUser | undefined | null): boolean => {
  return hasRole(user, SystemRoles.ADMIN)
}

/**
 * Obtiene el tipo de usuario principal (el primero que coincida según prioridad)
 */
export const getUserType = (user: UserDTO | LoggedUser | undefined | null): UserType | null => {
  if (!user?.roles || user.roles.length === 0) return null

  // Prioridad: ADMIN > MED > FAMILIAR > PATIENT
  if (isAdmin(user)) return SystemRoles.ADMIN
  if (isMed(user)) return SystemRoles.MED
  if (isFamiliar(user)) return SystemRoles.FAMILIAR
  if (isPatient(user)) return SystemRoles.PATIENT

  return null
}
